import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DevicesIcon(props: IconProps) {
    return <Icon {...props} iconKey={"devices"}/>
}
